import { useState } from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as InfoOutlineIcon } from "assets/icons/info-outline.svg";
import { FallbackProps } from "react-error-boundary";

import { Button } from "ui/button";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

export const ErrorFallback = ({
  error /* , resetErrorBoundary */,
}: FallbackProps) => {
  const isChunkError = error.name === "ChunkLoadError";
  const [isOpenPrompt, setIsOpenPrompt] = useState(isChunkError);

  if (!isChunkError) {
    throw error; // Rethrow non-chunk errors
  }

  const handleRefresh = () => {
    if ("caches" in window) {
      caches
        .keys()
        .then((keyList) =>
          Promise.all(keyList.map((key) => caches.delete(key)))
        );
    }
    window.location.reload();
  };

  return (
    <Modal
      isOpen={isOpenPrompt}
      setIsOpen={setIsOpenPrompt}
      allowOutsideClick={false}
      modalCss={{ ...defaultModalCss, width: "412px" }}
      position="center"
    >
      <Box className="flex flex-col">
        <ModalHeader
          modalType="others"
          HeaderIcon={
            <InfoOutlineIcon
              width="32px"
              height="32px"
            />
          }
          className="mb-0 justify-center"
        />
        <Heading3
          fontWeight="600"
          textColor="#101828"
          fontSize="18px"
          lineHeight="28px"
          className="text-center"
        >
          New Update Available
        </Heading3>
        <Paragraph3
          className="text-sm text-center mt-3 text-fade"
          fontWeight="400"
          textColor="#475467"
          lineHeight="20px"
        >
          We've released a new version of the app with the latest features and
          improvements. Please refresh the page to continue.
        </Paragraph3>
        <Box className="mt-6 flex items-center justify-center">
          <Button
            onClick={handleRefresh}
            variant="solid"
            textColor="#ffffff"
            border="1px solid #00535C"
            className="w-[170px]"
          >
            Refresh Page
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
